import { paramsSelector, useStore } from '@liveHelper/models/store'
import type { IAgoraRTCRemoteUser } from 'agora-rtc-sdk-ng'

import { useRemoteUsers } from '@core/agoraRTC'

/**
 * @returns The first remote user of the current chat channel.
 */
export const useAgentRTCUser = (): IAgoraRTCRemoteUser | undefined => {
  const params = useStore(paramsSelector)
  const remoteUsers = useRemoteUsers({
    logMultipleRemoteUsersError: true,
    channel: params.chat_channel_id,
  })
  const remoteUser = remoteUsers[0]

  return remoteUser
}
